define([
	"dojo/_base/declare",
	"csi/heading/AttributeSelectInline",
	"csi/widget/InlineSelect",
	"./RendererStoreMixin",
	"./String"
], function(declare,AttributeSelectInline,InlineSelect,RendererStoreMixin,StringRen) {

	return declare([StringRen, RendererStoreMixin], {
		/**@property {boolean} ignoreInvalid - true if string selection optional, all results are valid */
		//ignoreInvalid: false,

		tagAction: "ActionStringSelection",
		widgetClass: InlineSelect,

		isTabStop: function(/*Context*/ctx, /*Heading*/h) {
			// summary: string selection attributes can always be edited inline
			return true;
		},

		toHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*DOMNode*/refNode, /*Object*/params) {
			// summary: create store for values and select control to edit
			if (params.value == null) {
				params.value = this._getValue(ctx, h);
			}
			
			if (params.store == null) {
				params.store = this.getStore(ctx, h, params.value);
			}
			
			return new this.widgetClass(params);
		},

		fromHtmlDynamic: function(/*Context*/ctx, /*Heading*/h, /*InlineSelect*/editNode) {
			// summary: return attribute value from edit control
			return editNode.get("displayedValue");
		},

		/**
		 * @override
		 * Pass ignoreInvalid to store if necessary
		 */
		getStoreOptions(ctx, h) {
			return {ignoreInvalid: this.ignoreInvalid};
		},

		/**
         * @override
         * Reset action on store (if any) to remove Go to Dialog support
         * NOTE: Remove once aggregate stores can be used instead
         */
        getStore(ctx, h, value, bAll) {
            const store = this.inherited(arguments);

            if (store?.action) {
                store.action = null;
            }

            return store;
        },

		_getAction: function() {
			// summary: return action for selecting from relationship store
			return new AttributeSelectInline();
		},

		/** 
		 * @override
		 * return true if react renderer exists for given attribute type and should be used
		 */
		useReactInlineDialog() {
			return false;
		},
		
	});
});